var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('certificate-default',{attrs:{"infobike":_vm.infobike,"prezzi-vendere":_vm.prezziVendere,"prezzi-comprare":_vm.prezziComprare,"prezzi-assicurare":_vm.prezziAssicurare,"type":_vm.type,"vehicle_type":_vm.vehicle_type}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3feffd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/QuotationContainer.vue
// module id = s4me
// module chunks = 1